import { CustomError } from './CustomError';

export class VoiceChangeFailedError extends CustomError {
	description = 'Voice change failed';
	name = 'VoiceChangeFailedError';
}
